import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppSettings } from '@/types';

const initialState: AppSettings = {
  soundEnabled: true,
  autoSave: true,
  checkForUpdates: true,
  theme: 'poker',
  clockPosition: 'embedded',
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updateSettings: (state, action: PayloadAction<Partial<AppSettings>>) => {
      return { ...state, ...action.payload };
    },
    
    toggleSound: (state) => {
      state.soundEnabled = !state.soundEnabled;
    },
    
    toggleAutoSave: (state) => {
      state.autoSave = !state.autoSave;
    },
    
    setTheme: (state, action: PayloadAction<AppSettings['theme']>) => {
      state.theme = action.payload;
    },
    
    setClockPosition: (state, action: PayloadAction<AppSettings['clockPosition']>) => {
      state.clockPosition = action.payload;
    },
    
    loadSettings: (state, action: PayloadAction<AppSettings>) => {
      return { ...action.payload };
    },
    
    resetSettings: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateSettings,
  toggleSound,
  toggleAutoSave,
  setTheme,
  setClockPosition,
  loadSettings,
  resetSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;